

<ng-container *ngIf="!showEventPageThemeConfig; else eventPageThemeConfig">
  <div *ngIf="eventConfigData" class="row w-100" [formGroup]="config">
    <div class="col-12 d-flex px-0 mb-4">
      <div class="row mr-0">
        <div class="col">
          <div class="card-title d-flex align-items-center mb-3 mr-3">Event Page Configuration</div>
          <div class="card-desc d-flex align-items-center mb-3 mr-3">
            Customize the content on your event's webpage and share it with donors. You can include registration links, sponsors or sections with slides, campaigns or FAQs.
          </div>
        </div>

        <div class="d-flex align-items-start">
          <button class="btn btn--paybee btn-xs modal-outline-button" (click)="showPreview()">Preview Page </button>
        </div>
      </div>
    </div>
    
    <mdb-accordion [multiple]="true" [borderless]="true" class="col-12 px-0" style="border: none !important;">
      <mdb-accordion-item [collapsed]="false">
        <ng-template mdbAccordionItemHeader>General Settings</ng-template>
        <ng-template mdbAccordionItemBody>
          <div class="body-1--weight-medium mb-2">Page Theme</div>

          <div class="d-flex mb-4 justify-content-start align-items-center ">
            <mdb-form-control class="form-fill theme  mb-0 mr-3"  [ngStyle]="selectedTheme && selectedTheme.templateType === 10 && {'width': '60%'} || null" data-panel="settings">
              <mdb-select formControlName="eventTheme" class="mdb-select theme" optionHeight='48' [ngClass]="'theme-' + selectedThemeId ">
                <mdb-option *ngFor="let theme of allOrgThemes; index as i;" [value]="theme.id">{{
                  theme.name || ""
                }}
                <ng-container [ngSwitch]="theme.id">
                  <div class="theme-image" *ngSwitchCase="'earth'"><app-icon-earth-palette ></app-icon-earth-palette></div>
                  <div class="theme-image" *ngSwitchCase="'minimal'"><app-icon-minimal-palette></app-icon-minimal-palette></div>
                  <div class="theme-image" *ngSwitchCase="'tiffany'"><app-icon-tiffany-palette></app-icon-tiffany-palette></div>
                  <div class="theme-image" *ngSwitchCase="'holiday'"><app-icon-holidays-palette></app-icon-holidays-palette></div>
                  <div class="theme-image" *ngSwitchCase="'ocean'"><app-icon-ocean-palette></app-icon-ocean-palette></div>
                  <div class="theme-image" *ngSwitchCase="'purple'"><app-icon-purple-palette></app-icon-purple-palette></div>
                  <div class="theme-image" *ngSwitchCase="'positive'"><app-icon-positive-impact-palette></app-icon-positive-impact-palette></div>
                  <div class="theme-image" *ngSwitchCase="'empower'"><app-icon-empower-palette></app-icon-empower-palette></div>
                </ng-container>
              </mdb-option>
              <mdb-option [value]="null">
                <span class="create-new-theme"> Create New Theme</span>
              </mdb-option>
              </mdb-select>
            </mdb-form-control>
            <div class="btn btn--paybee btn-sm modal-outline-button text-center mr-3 custom-btn--paybee" *ngIf="selectedTheme && selectedTheme.templateType === 10" (click)="editCustomTheme()">Edit theme</div>
            <div class="btn btn--paybee btn-sm modal-outline-button text-center custom-btn--paybee" (click)="createCustomThemeFromCurrent()">Create Theme From Current</div>
          </div>

          <app-mdb-switch (change)="updateEventPage()"  data-panel="settings" class="theme-switch" label="Show sponsors on event page" formControlName="showSponsors"></app-mdb-switch>

          <app-mdb-switch (change)="updateEventPage()" data-panel="settings" class="theme-switch" label="Hide event date/time" formControlName="hideDateTime"></app-mdb-switch>
          <div style="padding-left: 44px;" *ngIf="config.value.hideDateTime">
              <mdb-form-control class="form-fill" data-panel="settings">
                  <div *ngIf="config.get('customDateTimeLabel').value !== eventConfigData.customDateTimeLabel" class="save-check button btn btn-xxs btn-success" (click)="onSaveEventPage()">Save</div>
                  <app-mdbp-input mdbInput formControlName="customDateTimeLabel" maxLength="1028" data-panel="general" label='Date Time Label (optional)'></app-mdbp-input>
              </mdb-form-control>
          </div>         

          <ng-container *ngIf="eventConfigData.hybridEventInfo">
            <app-mdb-switch (change)="updateInPersonDateDisplay()"  data-panel="settings" class="theme-switch" label="Hide in-person event" formControlName="hideInPerson"></app-mdb-switch>
          </ng-container>

          <ng-container *ngIf="eventConfigData.hybridEventInfo">
            <app-mdb-switch (change)="updateVirtualDateDisplay()"  data-panel="settings" label="Hide virtual event" formControlName="hideVirtual"></app-mdb-switch>
          </ng-container>

          <app-mdb-switch (change)="updateEventPage()"  data-panel="settings" class="theme-switch" label="Hide share buttons" formControlName="hideShareButtons"></app-mdb-switch>

        </ng-template>
      </mdb-accordion-item>

      <mdb-accordion-item [collapsed]="true">
        <ng-template mdbAccordionItemHeader>Header Settings</ng-template>
        <ng-template mdbAccordionItemBody>
          <div class="header-section">
            <div class="row">
              <div class="col-12 body-1--weight-medium pb-2">Header Image</div>
              <div class="col-4">
                <div  [ngClass]="{'square': [2, 3, 4].includes(selectedHeaderType) }" class="image-wrapper position-relative w-100">
                  <div
                    *ngIf="config.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                  >
                    <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                  </div>
                  <div
                    *ngIf="config.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                  >
                    <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetSlideImage()"></app-icon-delete>
                  </div>
                  <img style="border-radius: 5px" [src]="getBlockImageUrl(config.controls.imageDataUrl.value)">
                </div>
              </div>
            </div>

            <div class="row mb-4 mt-1">
              <div class="col-4 text-center">
                @if(config.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                  <span class="d-block blue-text body-2 text-center">OR</span>
                  <a (click)="openChooseImageModal(0)" class="blue-text body-2">Choose from previously used images</a>
                }
              </div>
            </div>

            <span class="body-1--weight-medium mb-2">Header Layout </span>
            <mdb-form-control appearance="fill" class="form-fill theme my-3 mr-3" data-panel="settings">
              <mdb-select formControlName="headerType" class="mdb-select theme" optionHeight='48'>
                <mdb-option *ngFor="let headerType of allHeaderTypes; index as i; trackBy:identify" [value]="headerType.id">{{
                  headerType.name || ""
                  }}
                </mdb-option>
              </mdb-select>
            </mdb-form-control>

            <div class="section-container">
              <ng-container *ngIf="selectedHeaderType === 1">
                <div class="section-visualization type-1">
                  <div class="title-container">
                    <div class="title-wrapper">
                      <div class="title">Event Title</div>
                      <div class="time"></div>
                      <div class="address"></div>
                    </div>
                    <div class="button-wrapper">
                      <div class="button">
                        <span>Register</span>
                      </div>
                      <div class="share-icons">
                        <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div>
                      </div>
                    </div>
                  </div>
                  <div class="event-desc">
                    Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
                    In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate commonly used
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedHeaderType === 2">
                <div class="section-visualization type-2">
                  <div class="col-6">
                    <div class="preview-image-2"></div>
                  </div>

                  <div class="col-6 p-3 right">
                    <div class="title-container">
                      <div class="title-wrapper">
                        <div class="title">Event Title</div>
                        <div class="time"></div>
                        <div class="address"></div>
                      </div>
                    </div>
                    <div class="event-desc">
                      Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
                      In publishing and graphic design.

                      <div class="button-wrapper">
                        <div class="button">
                          <span>Register</span>
                        </div>
                        <div class="share-icons">
                          <div class="icon"></div>
                          <div class="icon"></div>
                          <div class="icon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedHeaderType === 3">
                <div class="section-visualization type-3">
                  <div class="col-6 p-3 right">
                    <div class="title-container">
                      <div class="title-wrapper">
                        <div class="title">Event Title</div>
                        <div class="time"></div>
                        <div class="address"></div>
                      </div>
                    </div>
                    <div class="event-desc">
                      Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
                      In publishing and graphic design.

                      <div class="button-wrapper">
                        <div class="button">
                          <span>Register</span>
                        </div>
                        <div class="share-icons">
                          <div class="icon"></div>
                          <div class="icon"></div>
                          <div class="icon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="preview-image-3"></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedHeaderType === 4">
                <div class="section-visualization type-4">
                  <div class="col-6 p-3 right">
                    <div class="title-container">
                      <div class="title-wrapper">
                        <div class="title">Event Title</div>
                        <div class="time"></div>
                        <div class="address"></div>
                      </div>
                    </div>
                    <div class="event-desc">
                      <div class="button-wrapper">
                        <div class="button mr-4">
                          <span>Register</span>
                        </div>

                        <div class="button">
                          <span>Learn More</span>
                        </div>
                      </div>
                      <div class="w-100">
                        <div class="share-icons">
                          <div class="icon"></div>
                          <div class="icon"></div>
                          <div class="icon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="preview-image-4"></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="selectedHeaderType === 5">
                <div class="section-visualization type-5">
                  <div class="col-12 share-wrapper">
                    <div class="share-icons">
                      <div class="icon"></div>
                      <div class="icon"></div>
                      <div class="icon"></div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="title-container">
                      <div class="title-wrapper">
                        <div class="title">Event Title</div>
                        <div class="time"></div>
                        <div class="address"></div>
                      </div>
                    </div>
                    <div class="event-desc">
                      <div class="button-wrapper">
                        <div class="button mr-4">
                          <span>Register</span>
                        </div>

                        <div class="button">
                          <span>Learn More</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="preview-image-4"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <mdb-form-control class="form-fill" >
            <div *ngIf="config.get('name').value !== prevNameValue" class="save-check button btn btn-xxs btn-success" (click)="onSaveEventPage()">Save</div>
            <app-mdbp-input mdbInput formControlName="name" #name label='Header Title (optional)'></app-mdbp-input>
          </mdb-form-control>
          <div class="position-relative mb-4">
            <div *ngIf="config.get('desc').value !== prevDescValue" class="save-button button btn btn-xxs btn-success" (click)="onSaveEventPage()">Save</div>
            <label class="form-check-label form-check-label--paybee mb-1">Header Description (optional)</label>
            <mdb-form-control class="mb-4">     
              <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
            </mdb-form-control>
          </div>
        </ng-template>
      </mdb-accordion-item>

      <mdb-accordion-item [collapsed]="true">
        <ng-template mdbAccordionItemHeader>Registration Buttons</ng-template>
        <ng-template mdbAccordionItemBody>
          <app-mdb-switch (change)="updateEventPage()" data-panel="settings" class="theme-switch" label="Enable custom registration button label" formControlName="registrationButtonLabelRequired"></app-mdb-switch>
          <div style="padding-left: 44px;" *ngIf="config.value.registrationButtonLabelRequired">
              <mdb-form-control class="form-fill" data-panel="settings">
                <div *ngIf="config.get('registrationButtonLabel').value !== eventConfigData.registrationButtonLabel" class="save-check button btn btn-xxs btn-success" (click)="onSaveEventPage()">Save</div>
                <app-mdbp-input mdbInput formControlName="registrationButtonLabel" maxLength="16" data-panel="general" label='Registration Button Label'></app-mdbp-input>
                <mdb-error class="form-fill-error" *ngIf="config.controls.registrationButtonLabel.hasError('required') && config.controls.registrationButtonLabel.touched">Please provide Registration Button Label</mdb-error>
              </mdb-form-control>
          </div>

          <div class="event-config-section" [formGroup]="registrations">
            <app-registration-list
              [form]="registrations"
              [eventPageId]="eventInfo?.eventPageId"
              [registrations]="eventConfigData?.registrations"
              (onDrop)="updateEventPage()"
            ></app-registration-list>
          </div>
        </ng-template>
      </mdb-accordion-item>

      <mdb-accordion-item [collapsed]="sectionCollapsed">
        <ng-template mdbAccordionItemHeader>Sections</ng-template>
        <ng-template mdbAccordionItemBody>
          <div class="event-config-section">
            <div class="card__content w-100">
              <div class="section d-flex justify-content-between">
                <button class="btn btn--paybee btn-xs modal-primary-button" (click)="changeConfigMode()">Add Section</button>
              </div>
              <ul class="list-group ui-sortable" cdkDropList (cdkDropListDropped)="dropOption($event)">
                <li class="list-group-item" *ngFor="let block of eventConfigData.pageBlocks; index as i; trackBy:identify" cdkDragLockAxis="y"
                    cdkDrag>
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  <div class="preset-option d-flex">
                    <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
                      <app-icon-menu></app-icon-menu>
                    </div>
                    <div class="preset-option__content d-flex align-items-center">
                      <div class="preset-option__container d-flex flex-column">
                        <ng-container *ngIf="(block.type === 1)">
                          <div class="block-title" [innerHTML]="block.blockTitle"></div>
                          <div class="custom-text">
                            <span [innerHTML]="block.text"></span>
                          </div>
                        </ng-container>
      
                        <ng-container *ngIf="(block.type == 2)">
                          <div class="block-title" [innerHTML]="block.blockTitle"></div>
                          <ng-container *ngFor="let option of block.faq; index as i">
                            <div class="preset-option__name mb-1" [innerHTML]="option.question"></div>
                            <div class="preset-option__description mb-1" [innerHTML]="option.answer"></div>
                          </ng-container>
                        </ng-container>
      
                        <ng-container *ngIf="(block.type == 3)">
                          <app-org-event-page-slides [block]="block"></app-org-event-page-slides>
                        </ng-container>
      
                        <ng-container *ngIf="(block.type == 4)">
                          <div class="block-title" [innerHTML]="block.blockTitle || block.campaignData.name"></div>
                          <div class="campaign-desc-wrapper">
                                    <img class="preset-option__campaign-image" [src]="getBlockImageUrl(block.campaignData.imageUrl)" />
                            <div class="custom-text" [innerHTML]="block.campaignData.desc"></div>
                          </div>
                        </ng-container>
      
                        <ng-container *ngIf="(block.type == 5)">
                          <div class="block-title" [innerHTML]="block.blockTitle || block.campaignData.name"></div>
                          <div class="campaign-desc-wrapper">
                            <img class="preset-option__campaign-image" [src]="getBlockImageUrl(block.campaignData.imageUrl)" />
                            <div class="custom-text" [innerHTML]="block.campaignData.desc"></div>
                          </div>
                        </ng-container>
      
                      <ng-container *ngIf="(block.type == 6)">
                        <div class="block-title" [innerHTML]="block.blockTitle || block.campaignData.name"></div>
                        <div class="campaign-desc-wrapper">
                          <img class="preset-option__campaign-image" [src]="getBlockImageUrl(block.campaignData.imageUrl)" />
                          <div class="custom-text" [innerHTML]="block.campaignData.desc"></div>
                        </div>
                      </ng-container>
      
                      <ng-container *ngIf="(block.type == 7)">
                        <div class="block-title" [innerHTML]="block.blockTitle"></div>
                        <ng-container  *ngIf="!!block.videoData.desc; else elseOnlyVideo">
                          <div class="campaign-desc-wrapper">
                            <iframe class="preset-option__campaign-image" [src]="getVideoUrl(block.videoData) | safe" ></iframe>
                            <div class="custom-text" [innerHTML]="block.videoData.desc"></div>
                          </div>
                        </ng-container>
                        <ng-template #elseOnlyVideo>
                          <div class="campaign-desc-wrapper video-only">
                            <iframe class="preset-option__campaign-image" [src]="getVideoUrl(block.videoData) | safe" ></iframe>
                          </div>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngIf="(block.type == 8)">
                        <div class="block-title" [innerHTML]="block.blockTitle"></div>

                        <div *ngIf="block.text" class="campaign-desc-wrapper">
                          <img class="preset-option__campaign-image" [src]="getBlockImageUrl(block.imageUrl)">
                          <div class="custom-text" [innerHTML]="block.text"></div>
                        </div>

                        <div *ngIf="!block.text" class="campaign-desc-wrapper">
                          <div class="campaign-desc-wrapper photo-only">
                            <img class="preset-option__campaign-image" [src]="getBlockImageUrl(block.imageUrl)">
                          </div>
                        </div>

                      </ng-container>
                    </div>
                    
                    <div class="preset-option__actions">
                        <div class="preset-option__action">
                          <app-icon-pen (click)="editSection(i)"></app-icon-pen>
                        </div>
                        <div class="preset-option__action justify-content-end" (click)="removeSection(i)">
                          <app-icon-trash></app-icon-trash>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop blocks to reorder or use Move.</div>
        </ng-template>
      </mdb-accordion-item>
    </mdb-accordion>
  </div>
</ng-container>

<ng-template #eventPageThemeConfig>
  <app-event-page-custom-theme-configuration
    (onDeleteTheme)="deleteCustomTheme($event)"
    (onSaveTheme)="saveCustomTheme($event)"
    [selectedTheme]="initialTheme"
    [themeAction]="themeAction"
    [headerType]="eventConfigData.layout.headerType"
  ></app-event-page-custom-theme-configuration>
</ng-template>
